// src/components/common/CityInput.js - Generic City Input
import React from "react";
import { MapPin } from "lucide-react";
import "./CityInput.css";

const CityInput = ({
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  placeholder = "Enter city/district",
  className = "",
}) => {
  return (
    <div className={`city-input-wrapper ${className}`}>
      <div className="city-input-container">
        <MapPin size={16} className="city-icon" />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          className={`city-input ${error ? "error" : ""}`}
        />
      </div>
      {error && <span className="city-error">{error}</span>}
    </div>
  );
};

export default CityInput;
